// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LYpk1KFvg8bM7r0vPbmg {\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n", "",{"version":3,"sources":["webpack://./client/src/App.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB","sourcesContent":[".loadingWrapper {\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingWrapper": "LYpk1KFvg8bM7r0vPbmg"
};
export default ___CSS_LOADER_EXPORT___;
